export default __webpack_public_path__ + "static/media/facebook.fe5d2440.svg";